interface Props {
  children?: React.ReactNode;
}

export const TableContainer: React.FC<Props> = ({ children }) => {
  return (
    <div className="overflow-x-auto w-full">
      <div className="inline-block min-w-full align-middle">
        <div className="overflow-hidden ring-1 ring-black ring-opacity-5 rounded-sm">
          {children}
        </div>
      </div>
    </div>
  );
};
